module.exports = __webpack_public_path__ + "img/icon_sec4_2@2x.2f406c21.png";